import { render, staticRenderFns } from "./DialogNotification.vue?vue&type=template&id=134ab9a4"
import script from "./DialogNotification.js?vue&type=script&lang=js&external"
export * from "./DialogNotification.js?vue&type=script&lang=js&external"
import style0 from "./DialogNotification.vue?vue&type=style&index=0&id=134ab9a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports